import { createAction } from 'redux-starter-kit';
import { addUsers, putUser } from '../users/userActions';
import { selectUser } from '../users/userReducer';

/**
 * Normalizes an inspection note and returns the objects within.
 * @param {object} note An inspection note.
 * @returns {object} An object of the following structure  { normalizedNote, createdBy }
 */
function normalizeNote(note) {
  const normalizedNote = {
    ...note,
    createdByUser: note.createdByUser ? note.createdByUser.userId : undefined,
  };

  return {
    normalizedNote,
    createdByUser: note.createdByUser,
  };
}

/**
 * An action creator for putting an inspection note into the store.
 * @param {object} note An inspection note.
 * @example dispatch(putInspectionNote(note));
 */
export const putNormalizedInspectionNote = createAction('PUT_INSPECTION_NOTE');

export function putInspectionNote(note) {
  return (dispatch, getState) => {

    const { normalizedNote, createdByUser } = normalizeNote(note);

    // The createdByUser is only partial user data (id and display name).
    // so we update the existing user if loaded in the state.
    dispatch(putUser({ ...selectUser(getState(), normalizedNote.createdByUser), ...createdByUser }))

    // Store the normalized inspection.
    dispatch(putNormalizedInspectionNote(normalizedNote));
  };
}

/**
 * An action creator for adding inspection notes into the store.
 * @param {object[]} notes An array of inspection notes.
 * @example dispatch(addInspectionNotes(notes))
 */
export const addNormalizedInspectionNotes = createAction('PUT_INSPECTION_NOTES');

export function addInspectionNotes(inspectionNotes) {
  return (dispatch, getState) => {
    const normalizedNotes = [];
    const users = [];

    inspectionNotes.forEach((note) => {
      const { normalizedNote, createdByUser } = normalizeNote(note);
      normalizedNotes.push(normalizedNote);

      // The createdByUser is only partial user data (id and display name).
      // so we update the existing user if loaded in the state.
      users.push({ ...selectUser(getState(), normalizedNote.createdByUser), ...createdByUser });
    });

    dispatch(addUsers(users));
    dispatch(addNormalizedInspectionNotes(normalizedNotes));
  };
}
